import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PickingService from '../../../services/PickingService';
import { translate, formatData, isNullOrEmpty, closeCollapsible } from '../../../utils/util';
import { Input, BackButton, Title, Button, InfiniteScroll, Collapsible } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';

const LogGcp = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [logs, setLogs] = useState([]);
    const [filter, setFilter] = useState(
        {
            dateStart: "",
            dateEnd: ""
        });

    useEffect(() => {
        if (props.logs?.items?.length > 0) {
            if (logs.length > 0 && currentPage === 0) {
                setLogs([...props.logs.items]);
            } else {
                setLogs((prevState) => ([...prevState, ...props.logs.items]));
            }
        } else {
            setLogs([]);
        }
        // eslint-disable-next-line
    }, [props?.logs?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            getErrorLogFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const getErrorLogFilter = () => {
        if (validateInputsRequired("getReport")) {
            Object.assign(filter, {
                PageSize: 20,
                PageIndex: currentPage
            });
            props.getLogGcp(filter, () => {
                closeCollapsible("collapsible2")
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('log-gcp', 'expedition:picking')} />
            </div>
            <div className="title" style={{ float: 'right', margin: '5px' }}>
                <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => props.forceResend(() => window.location.reload())}>{'refresh'}</i>
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col m6 s12">
                                            <Input
                                                defaultValue={filter.dateStart}
                                                type="date"
                                                label={translate('date-start', 'expedition:picking')}
                                                id="dateStart"
                                                name="dateStart"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col m5 s12">
                                            <Input
                                                defaultValue={filter.dateEnd}
                                                type="date"
                                                label={translate('date-end', 'expedition:picking')}
                                                id="dateEnd"
                                                name="dateEnd"
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => getErrorLogFilter()} />
                                </div>
                            </>
                        }
                    />
                </div>
                <div id="loglistGcp">
                    <InfiniteScroll
                        page={props.logs?.totalPages}
                        hasMore={currentPage < props.logs?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={logs.map((item) => (
                            <div
                                className="row"
                                style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                            >
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {item.id}
                                </span>
                                {
                                    !item?.success && (
                                        <div className="col s12 second-text-color"  >
                                            {translate('line-picking:transmission.erro-send')} - {formatData(item.createdOn)}
                                        </div>
                                    )
                                }
                                {
                                    item?.success && (
                                        <div className="col s12 second-text-color"  >
                                            {translate('line-picking:transmission.send')} - {formatData(item?.createdOn || '')}
                                        </div>
                                    )
                                }
                                <div className="col s12 second-text-color">
                                    {translate('attempts', 'physical-confirmation')}: {item.attempts || ''}
                                </div>
                                {
                                    !isNullOrEmpty(item.message) && (
                                        <div className="col s12 second-text-color"  >
                                            {translate('message', 'physical-confirmation')}: {item.message || ''}
                                        </div>
                                    )
                                }
                            </div>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        logs: state.pickingReducer.logs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLogGcp: (filter, callback) => {
            dispatch(PickingService.getLogGcpPaged(filter, callback));
        },
        forceResend: (callback) => {
            dispatch(PickingService.forceResend(callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogGcp)));
